import { createAsyncReducer } from "@telstra-connect/standard-actions/reducers";
import {
    ISubmitOrderAction,
    ISubmitOrderSuccessAction,
    ISubmitOrderErrorAction,
} from "../actions/submit-order/submit-order";
import { IStoreIntState } from "../state";
import { initialState } from "../state/initial-state";

export type SubmitOrderAction = ISubmitOrderAction | ISubmitOrderSuccessAction | ISubmitOrderErrorAction;

const init = (state: IStoreIntState, action: SubmitOrderAction) => ({
    ...state,
    submitOrder: {
        ...state.submitOrder,
        status: action.status,
    },
});

const success = (state: IStoreIntState, action: SubmitOrderAction) => {
    return {
        ...state,
        submitOrder: {
            ...state.submitOrder,
            status: action.status,
            data: (action as ISubmitOrderSuccessAction).data,
        },
    };
};

const failure = (state: IStoreIntState, action: SubmitOrderAction) => ({
    ...state,
    submitOrder: {
        ...initialState.submitOrder,
        status: action.status,
        error: (action as ISubmitOrderErrorAction).error,
    },
});

export const submitOrder = createAsyncReducer(
    initialState,
    init,
    success,
    failure,
);
